import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#000000', cx: '12', cy: '12', r: '12' }),
    React.createElement("circle", { key: '1', fill: '#FFFFFF', cx: '12', cy: '12', r: '10' }),
    React.createElement("path", { key: '2', fill: '#000000', d: 'M8,18.6V5.7h4.2c1.6,0,2.6,0.1,3.1,0.2c0.7,0.2,1.4,0.6,1.9,1.3s0.7,1.5,0.7,2.5c0,0.8-0.1,1.5-0.4,2s-0.7,1-1.1,1.3\n\ts-0.9,0.5-1.3,0.6c-0.6,0.1-1.5,0.2-2.7,0.2h-1.7v4.9H8V18.6z M10.6,7.9v3.7H12c1,0,1.7-0.1,2.1-0.2s0.6-0.3,0.8-0.6s0.3-0.6,0.3-1\n\tc0-0.5-0.1-0.9-0.4-1.2s-0.6-0.5-1-0.6c-0.3-0.1-0.9-0.1-1.9-0.1H10.6z' }),
], 'TransportConditionParkingLong');
const TransportConditionParkingLongIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionParkingLongIcon);
